import React from "react";
import Response from "../../components/responses/Response.js";

function FormResponse() {
  return (
    <div>
      <Response />
    </div>
  );
}

export default FormResponse;
